import React from "react";
import { Phone, MessageSquareText, Mail } from "lucide-react";
import { useSite } from "../../context/SiteContext";
import { links } from "../../lib/api";
import { WhatsAppLogo } from "../home/ContactStrip";

const Round = ({ href, label, cls, size, children, testid }) => (
  <a href={href} target={href.startsWith("http") ? "_blank" : undefined} rel="noreferrer" aria-label={label} title={label}
    className={`group relative flex items-center justify-center rounded-full text-white shadow-[0_12px_28px_-10px_rgba(0,0,0,.5)] ring-4 ring-white transition-transform duration-200 hover:scale-110 ${size} ${cls}`} data-testid={testid}>
    {children}
    <span className="pointer-events-none absolute left-full ml-3 hidden whitespace-nowrap rounded-full bg-[#0f2e2a] px-3 py-1.5 text-[13px] font-bold text-white opacity-0 transition-opacity group-hover:opacity-100 md:block">{label}</span>
  </a>
);

export default function FloatingContact() {
  const { content, t } = useSite();
  const l = links(content);
  if (!content?.whatsapp_raw && !content?.phone_raw) return null;
  return (
    <div className="fixed bottom-[78px] left-3 z-[44] hidden xl:flex flex-col items-center gap-3 md:bottom-6 md:left-6" data-testid="floating-contact">
      {content?.email && <Round href={l.mail} label={`${t("Email")} ${content.email}`} cls="bg-[#0e8c7f] !hidden md:!flex" size="h-11 w-11 md:h-12 md:w-12" testid="float-email">
        <Mail size={20} strokeWidth={2.6} />
      </Round>}
      <Round href={l.sms} label={`${t("Text Us")} ${content?.phone_display || ""}`} cls="bg-[#2563eb] !hidden md:!flex" size="h-12 w-12 md:h-14 md:w-14" testid="float-text">
        <MessageSquareText size={24} strokeWidth={2.6} />
      </Round>
      <Round href={l.tel} label={`${t("Call Us")} ${content?.phone_display || ""}`} cls="bg-[#0f2e2a] !hidden md:!flex" size="h-12 w-12 md:h-14 md:w-14" testid="float-call">
        <Phone size={24} strokeWidth={2.6} />
      </Round>
      <Round href={l.wa} label={`WhatsApp ${content?.whatsapp_display || ""}`} cls="bg-[#25D366]" size="h-14 w-14 md:h-[72px] md:w-[72px]" testid="float-whatsapp">
        <span className="absolute inset-0 -z-10 animate-ping rounded-full bg-[#25D366] opacity-40" />
        <WhatsAppLogo size={34} />
      </Round>
    </div>
  );
}
